module.exports = __webpack_public_path__ + "static/media/CSS.7415a70a.svg";